var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWiredEarphones = function SvgWiredEarphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wiredEarphones_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__b)",
    d: "M15.23 24.92c-1.316 1.47-3.426 2.855-5.466 4.193C6.542 31.23 3.137 33.905 3.637 36H2.064c-.177-1.407.456-3.075 1.82-4.437 1.296-1.296 3.193-2.542 5.028-3.747 1.957-1.284 3.98-2.612 5.162-3.932 2.995-3.344-2.73-9.354-2.788-9.415a.777.777 0 0 1 1.117-1.077c.067.07 1.667 1.74 2.846 3.938 2.098 3.913 1.148 6.287-.019 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__c)",
    d: "M30.002 22.826c-.031.105-.785 2.603-3.121 5.63-1.62 2.1-5.116 5.202-9.592 7.545h-3.727c5.609-2.2 10.185-6.041 12.045-8.435 2.181-2.806 2.9-5.156 2.907-5.18a.776.776 0 0 1 1.488.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__d)",
    d: "M12.686 12.924c.196.346.218.7.122 1.006-.234.759-1.179 1.242-1.965.693-4.323-3.02-7.235-12.143.035-13.34 1.598 1.048 3.098 3.819 1.76 6.561a6 6 0 0 1-.222.41c-2.062.067-.613 3.107.27 4.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E80D1",
    d: "M12.809 13.93c-.528-.275-1.255-.9-2.216-2.209-2.432-3.314.496-7.262.496-7.262h.819l.73 3.385a6 6 0 0 1-.222.41c-2.061.067-.613 3.107.27 4.67.197.347.218.7.123 1.006"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__e)",
    d: "M16.1 8.076c-1.623 1.116-2.813 1.07-3.683.18-.604-.618-1.055-1.644-1.392-2.969-.361-1.42-.685-2.966-.147-4.003.257-.494.708-.872 1.446-1.067 5.92-1.56 6.887 5.722 3.777 7.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.59 5.417c.412-.118.501-1.067.2-2.121s-.879-1.812-1.29-1.695c-.412.118-.502 1.068-.2 2.121.3 1.054.878 1.812 1.29 1.695"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__f)",
    d: "M27.5 15.28c-2.803 1.175-5.21-3.278-3.446-6.235 1.934-3.238 6.862-1.863 6.868-.148.435 4.775.878 4.923-3.422 6.384"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__g)",
    d: "M30.736 22.694c-.565 1.108-2.622 1.108-2.381-.03.5-2.373.666-4.063.647-5.267-.39-1.128-.97-1.653-1.502-2.116a4 4 0 0 1-.375-.368c-2.318-2.563-.146-6.558 3.797-6.015.992.136 1.896.595 2.417 1.372 2.163 3.229-1.923 11.089-2.603 12.424"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E80D1",
    d: "M29.002 17.398c-.39-1.128-.97-1.653-1.501-2.116a4 4 0 0 1-.376-.368c.049-.41.483-.517.683-.493 0 0 1.15.025 1.194 2.977"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wiredEarphones_svg__d",
    x1: 12.179,
    x2: 3.654,
    y1: 0.206,
    y2: 8.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#378CF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wiredEarphones_svg__e",
    x1: 16.78,
    x2: 11.63,
    y1: -0.707,
    y2: 7.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wiredEarphones_svg__f",
    x1: 30.061,
    x2: 25.488,
    y1: 6.421,
    y2: 14.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wiredEarphones_svg__g",
    x1: 32.83,
    x2: 23.59,
    y1: 7.684,
    y2: 16.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BC7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#378CF7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wiredEarphones_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.9063 20.0944 -16.83528 -7.46178 10.402 15.835)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wiredEarphones_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-10.14878 12.46227 -13.80024 -11.23837 23.097 23.495)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wiredEarphones_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgWiredEarphones;